import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

//get All expense Forms
export const getForms = createAsyncThunk('formSlice/getForms', async () => {
    try {
        let response = await axios.get('/expense-form', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form by Id
export const getFormbyId = createAsyncThunk('formSlice/getFormbyId', async (id) => {
    try {
        let response = await axios.get(`/expense-form/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form Category Options
export const getFormCategoryOptions = createAsyncThunk('formSlice/getFormCategoryOptions', async (expenseFormId) => {
    try {
        let response = await axios.get(`/expense-form/category/options?expenseFormId=${expenseFormId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Get Expense Form Category Options
export const getFormMaterialCategoryOptions = createAsyncThunk('formSlice/getFormCategoryOptions', async (expenseFormId) => {
    try {
        let response = await axios.get(`expense-form/material-category/options?expenseFormId=${expenseFormId}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Edit Expense Form Category 
export const updateFormCatrogies = createAsyncThunk('formSlice/updateFormCatrogies', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/expense-form/category/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Form Categories updated successfully.');
        dispatch(getForms());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

export const deleteItem = createAsyncThunk('formSlice/deleteItem', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/item/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Item deleted successfully.');
        await dispatch(getItem());

        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const formSlice = createSlice({
    name: 'formSlice',
    initialState: {
        data: [],
        formData: {}
    },
    extraReducers: (builder) => {
        builder.addCase(getForms.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getFormbyId.fulfilled, (state, action) => {
            state.formData = action?.payload;
            return;
        });
    }
});

export default formSlice.reducer;
